import React, { useState } from 'react';

import { Fab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EntryPopup from './entryPopup';
import AddMenu from './addMenu';
import EntryTable from './entryTable';


import Status from './status';
import Currently from './Currently';
import Toolbar from './Toolbar';
import Blorbos from './blorbos';

export default function AppContents() {
  const [addMenu, setAddMenu] = useState(false);
  const [updater, triggerUpdate] = useState(0);
  const [entryPopup, openPopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [pageName, setPageName] = useState('status');

  const handleMenu = (mybool) =>{
    setAddMenu(true);
    console.log("inhandlemenu")
  }

  return (
    <div className="App">
       <div className='website-container'>
        <Toolbar pageName={pageName} setPageName={setPageName} />
        <h1>my app :)</h1>
      {(() => {
        switch (pageName) {
          case 0:
            return <Status />
          case 1:
            return <Currently />
          case 2:
            return <Blorbos />
          default:
            return <Status />
        }
      })()}

        </div>
    </div>
  );
}